import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=78739f40&scoped=true&"
var script = {}
import style0 from "./Notfound.vue?vue&type=style&index=0&id=78739f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78739f40",
  null
  
)

export default component.exports